import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap";
import BootstrapIcon from "@dvuckovic/vue3-bootstrap-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faStream } from "@fortawesome/free-solid-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faFax } from "@fortawesome/free-solid-svg-icons";
import { faHatWizard } from "@fortawesome/free-solid-svg-icons";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
library.add(faStream);
library.add(faBars);
library.add(faPhone);
library.add(faEnvelope);
library.add(faFax);
library.add(faHatWizard);
library.add(faCaretDown);
// Custom Styles
import "./assets/css/style.scss";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { createI18n } from "vue-i18n";
// // 准备翻译的语言环境信息
const messages = {
  EN: {
    // Home Page
    homePage: {
      // Header
      header: {
        home: "Home",
        about: "About Us",
        contact: "Contact Us",
        service: "Service",
        faq: "FAQ",
      },
      // Hero
      hero: {
        companyName: "Perfect Gardening Inc.",
        subtitle:
          " The greatest results for your landscaping through hard work and expert knowledge in home services ",
      },
      // Intro
      introduction: {
        title: "About Us",
        text: "{introduction}",
      },
      // Service
      service: {
        title: "Service Area",
        price: "Price",
      },
      // Cases
      cases: {
        title: "Our Work",
      },
      // FAQ
      faq: {
        title: "Frequently Asked Questions",
      },
      // Chat Button
      chatBtn: {
        chat: "Chat",
        form: {
          title: "Contact Us",
          name: "Name",
          namePlaceHolder: "Full Name",
          email: "Email",
          emailPlaceHolder: "Email Address",
          phone: "Phone",
          phonePlaceHolder: "Phone Number",
          message: "Message",
          messagePlaceHolder: "Message Content",
          send: "Send",
        },
      },
      // Footer
      footer: {
        title: "Contact Information",
      },
    },
  },
  CH: {
    // Home Page
    homePage: {
      // Header
      header: {
        home: "首页",
        about: "关于我们",
        contact: "联系我们",
        service: "服务",
        faq: "常见问题",
      },
      // Hero
      hero: {
        companyName: "完美园林",
        subtitle: "通过匠心栽培和专业学识为你的家园带来最佳风光",
      },
      // Intro
      introduction: {
        title: "关于我们",
      },
      // Service
      service: {
        title: "服务范围",
        price: "价格",
      },
      // Cases
      cases: {
        title: "往期成果",
      },
      // FAQ
      faq: {
        title: "常见问题",
      },
      // Chat Button
      chatBtn: {
        chat: "咨询",
        form: {
          title: "欢迎询问",
          name: "姓名",
          namePlaceHolder: "全名",
          email: "邮箱",
          emailPlaceHolder: "邮箱地址",
          phone: "电话",
          phonePlaceHolder: "电话号码",
          message: "内容",
          messagePlaceHolder: "请输入内容",
          send: "发送",
        },
      },
      // Footer
      footer: {
        title: "联络方式",
      },
    },
  },
};

const i18n = createI18n({
  locale: "EN", // set locale
  fallbackLocale: "CH", // set fallback locale
  messages,
});

const app = createApp(App);
// Global Properties
// Web Domain
app.config.globalProperties.$webDomain = "https://eadate.com";

app
  .use(store)
  .use(router)
  .use(i18n)
  .component("font-awesome-icon", FontAwesomeIcon)
  .component("BootstrapIcon", BootstrapIcon)
  .mount("#app");
